const DEBUG_PARAMS = new URLSearchParams(window.location.search);
const DEBUG_MODE = DEBUG_PARAMS.has("debug");

const debug = DEBUG_MODE ? console.log.bind(console, '[DEBUG]') : () => {};

function dragScrollBehavior(container) {
  let pos = { top: 0, left: 0, x: 0, y: 0 };

  let dragging = false;
  let disableClick = false;

  const clickHandler = function (e) {
    if (disableClick) {
      e.stopPropagation();
      e.preventDefault();
    }
  };

  const mouseDownHandler = function (e) {
    if (!dragging && window.innerWidth >= 750) {
      pos = {
        // The current scroll
        left: container.scrollLeft,
        top: container.scrollTop,
        // Get the current mouse position
        x: e.clientX,
        y: e.clientY,
      };

      dragging = true;

      document.addEventListener("mousemove", mouseMoveHandler);
      document.addEventListener("mouseup", mouseUpHandler);

      container.style.cursor = "grabbing";
      container.style.userSelect = "none";
    }
    e.preventDefault();
  };

  const mouseMoveHandler = function (e) {
    // How far the mouse has been moved
    const dx = e.clientX - pos.x;
    const dy = e.clientY - pos.y;

    // Scroll the element
    container.scrollTop = pos.top - dy;
    container.scrollLeft = pos.left - dx;
  };

  const mouseUpHandler = function () {
    if (Math.abs(container.scrollLeft - pos.left) > 10) {
      disableClick = true;
      setTimeout(() => (disableClick = false), 10);
    }

    dragging = false;

    document.removeEventListener("mousemove", mouseMoveHandler);
    document.removeEventListener("mouseup", mouseUpHandler);

    container.style.cursor = "grab";
    container.style.removeProperty("user-select");
  };

  if (true) {
    container.addEventListener("mousedown", mouseDownHandler);
    container.addEventListener("click", clickHandler);
  } else {
    Array.from(container.children).forEach((child) => {
      child.addEventListener("mousedown", mouseDownHandler);
      child.addEventListener("click", clickHandler);
    });
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  getValue() {
    return this.input.value;
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        document.body.classList.add("menu-drawer-open");
        document.querySelector('html').classList.add("menu-drawer-open");
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  enableScrolling() {
    if (false) {
      this.scrollPosition = window.pageYOffset;
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.top = `-${this.scrollPosition}px`;
      document.body.style.width = "100%";
    }
  }

  disableScrolling() {
    if (false) {
      document.body.style.removeProperty("overflow");
      document.body.style.removeProperty("position");
      document.body.style.removeProperty("top");
      document.body.style.removeProperty("width");

      if (this.scrollPosition) {
        window.scrollTo(0, scrollPosition);
      }
    }
  }

  openMenuDrawer(summaryElement) {
    console.debug("Open menu drawer");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add("menu-drawer-open");
    document.querySelector('html').classList.add("menu-drawer-open");
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    this.disableScrolling();
  }

  closeMenuDrawer(event, elementToFocus = false) {
    
    
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });

      this.enableScrolling();
      document.body.classList.remove("menu-drawer-open");
      document.querySelector('html').classList.remove("menu-drawer-open");
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    document.querySelector('.header__search details').addEventListener('toggle', () => {
      this.closeMenu();
    });
    document.addEventListener('open-cart', () => {
      this.closeMenu();
    });
  }

  closeMenu() {
    const summary = this.querySelector('details summary');
    const details = this.querySelector('details');
    const pointerEvent = new PointerEvent('summary');
    this.closeMenuDrawer(pointerEvent, summary);
    details.removeAttribute('open');
    details.setAttribute('aria-expanded', false);
    summary.setAttribute('aria-expanded', false);
  }
  openMenuDrawer(summaryElement) {
    window.scrollTo({ top: 0 });
    this.header =
      this.header || document.getElementById("shopify-section-td-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add("menu-drawer-open");
    document.querySelector('html').classList.add("menu-drawer-open");
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      (event) => {
        this.hide();
        event.preventDefault();
        event.stopPropagation();
      }
    );

    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });

    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") {
          this.hide();
          event.preventDefault();
          event.stopPropagation();
        }
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    this.sliderLastItem =
      this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderLastItem.clientWidth
        : this.slider.scrollLeft - step * this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector("a");
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute("tabindex");
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (button) button.setAttribute("tabindex", "-1");
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    debug('[VariantSelects] Variant change')
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    if (!this.currentVariant) {
      debug('[VariantSelects] Variant change: No variant selected')

      this.toggleAddButton(true, "", true);
      this.setUnavailable(true);
    } else {
      debug('[VariantSelects] Variant change: Variant selected:', this.currentVariant)

      this.toggleAddButton(false, "", false);
      //this.setUnavailable(false);
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    console.debug("Variant data", this.getVariantData());
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    debug('Update media', { currentVariant: this.currentVariant, featuredMedia: this.currentVariant.featured_media })
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const mediaGallery = document.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGallery.dispatchEvent(new CustomEvent('go-to-slide', {detail: {position: this.currentVariant.featured_media.position}}));

    console.debug(
      "Update media",
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`
    );

    mediaGallery.setActiveMedia(
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
      true
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );

    if (modalContent) {
      const newMediaModal = modalContent.querySelector(
        `[data-media-id="${this.currentVariant.featured_media.id}"]`
      );
      modalContent.prepend(newMediaModal);
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        try {
          Array.from(
            document.querySelectorAll(
              `[data-price][data-section="${this.dataset.section}"] [data-price-value]`
            )
          ).forEach((price) => {
            const newPriceValue = source
              .querySelector(".price-item--sale")
              .innerText.trim();
            console.log("New price value", newPriceValue);
            price.innerText = newPriceValue;
          });
        } catch (e) {
          console.error("Price update error", e);
        }

        const price = document.getElementById(`price-${this.dataset.section}`);
        this.updateFinalPrice();
        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonPrice = productForm.querySelector(
      '[name="add"] [data-price-value]'
    );
    const addButtonText = productForm.querySelector('[name="add"] .text');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (addButtonText && text) addButtonText.textContent = text;
      if (addButtonPrice) {
        addButtonPrice.style.display = "none";
      }
    } else {
      addButton.removeAttribute("disabled");
      if (addButtonPrice) {
        addButtonPrice.style.display = null;
      }
      if (addButtonText) {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable(disabled) {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = disabled
      ? window.variantStrings.unavailable
      : window.variantStrings.addToCart;

    if (disabled) {
      if (price) price.classList.add("visibility-hidden");
    } else {
      price.classList.remove("visibility-hidden");
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateFinalPrice() {
    const finalPriceElms = document.querySelectorAll('[data-product-final-price]');
    let currentPrice = this.currentVariant.price
    if(!finalPriceElms) return;
    finalPriceElms.forEach((priceEl) => priceEl.innerHTML = Shopify.formatMoney(currentPrice));
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const selectedValue = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      const renderedValue = fieldset.querySelector('[data-current-value]');
      if (renderedValue) { renderedValue.innerHTML = selectedValue; }
      return selectedValue;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class VariantPicker extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const optionFields = Array.from(
      this.querySelectorAll("[data-variant-picker-option]")
    );
    console.debug({ optionFields });
    this.options = optionFields.map((optionField, index) => {
      console.debug({ optionField });
      if (optionField.dataset.optionFieldType == "select") {
        return optionField.querySelector("select").value;
      } else if (optionField.dataset.optionFieldType == "radio") {
        const inputs = Array.from(optionField.querySelectorAll("input"));
        return inputs.find((radio) => radio.checked).value;
      }
    });

    console.debug("Variant options", this.options);
  }
}

customElements.define("variant-picker", VariantPicker);

class ProductCardMediaGallery extends HTMLElement {
  constructor() {
    super();
  }

  setActiveMedia(mediaId) {
    this.parentElement.classList.remove("js-gallery-active");

    Array.from(this.querySelectorAll(`[data-media-id]`)).forEach((media) =>
      media.classList.remove("js-active")
    );

    const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
    if (activeMedia) {
      this.parentElement.classList.add("js-gallery-active");
      activeMedia.classList.add("js-load");

      setTimeout(() => {
        activeMedia.classList.add("js-active");
      }, 10);
    }
  }
}

customElements.define("product-card-media-gallery", ProductCardMediaGallery);

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();

    setTimeout(() => {
      this.style.display = null;
      this.classList.add("js-loaded");
    }, 100);

    this.cookieName = "newsletter-popup-closed";
    this.autoShow = this.dataset.autoShow;

    this.lock = false;

    console.debug("Popup init", { cookie: Cookies.get(this.cookieName) });

    ["shopify:section:select", "shopify:section:load"].forEach((eventName) =>
      document.addEventListener(eventName, (event) => {
        if (event.detail.sectionId == "newsletter-popup") {
          this.show();
        }
      })
    );

    document.addEventListener("shopify:section:deselect", (event) => {
      if (event.detail.sectionId == "newsletter-popup") {
        this.close();
      }
    });

    window.addEventListener("popup:open", (event) => {
      const popupID = event.detail;

      if (popupID == "signup") {
        this.show();
      }
    });

    if (location.hash == `#${this.dataset.formId}`) {
      console.debug("Successfully subscribed");
      setTimeout(() => {
        this.classList.add("js-success");
        this.show();
      }, 500);
    } else {
      setTimeout(
        () => {
          if (this.canShow()) {
            this.show();
          }
        },
        this.isDebugMode() ? 500 : 5000
      );
    }

    this.closeButton = this.querySelector("[data-close-button]");

    this.closeButton.addEventListener("click", () => {
      this.close();
    });

    this.addEventListener("click", (event) => {
      if (event.target === this) {
        this.close();
      }
    });
  }

  isDebugMode() {
    return DEBUG_MODE && DEBUG_PARAMS.has("show-newsletter-popup");
  }

  canShow() {
    return (
      (Cookies.get(this.cookieName) != "true" && this.autoShow == "true") ||
      this.isDebugMode()
    );
  }

  show() {
    this.lock = true;
    this.classList.add("js-visible");

    setTimeout(() => {
      this.lock = false;
    }, 500);
  }

  close() {
    if (!this.lock) {
      Cookies.set(this.cookieName, true, { expires: 365 });
      this.classList.remove("js-visible");
    }
  }
}

customElements.define("newsletter-popup", NewsletterPopup);

class BarrowsGreenMap extends HTMLElement {
  constructor() {
    super();

    this.layers = Array.from(this.querySelectorAll("[data-layer]"));
    this.cards = Array.from(this.querySelectorAll("[data-card]"));
    this.areas = Array.from(this.querySelectorAll("area"));

    this.frameInner = this.querySelector("[data-frame-inner]");
    this.map = this.querySelector("[data-map]");

    if (this.cards[0] && window.innerWidth < 750) {
      this.cards[0].classList.add("js-visible");
    }

    this.cards.forEach((card, index) => {
      const prevCard = index >= 1 ? this.cards[index - 1] : null;
      const nextCard =
        index < this.cards.length - 1 ? this.cards[index + 1] : null;

      const prevButton = card.querySelector("[data-button-prev]");
      const nextButton = card.querySelector("[data-button-next]");

      prevButton.addEventListener("click", () => {
        this.hideCard(card);
        this.showCard(prevCard);
        this.showLayer(prevCard.dataset.layerId);
      });

      nextButton.addEventListener("click", () => {
        this.hideCard(card);
        this.showCard(nextCard);
        this.showLayer(nextCard.dataset.layerId);
      });
    });

    this.areas.forEach((area) => {
      area.addEventListener("mouseenter", this.onAreaMouseEnter.bind(this));
      area.addEventListener("mouseleave", this.onAreaMouseLeave.bind(this));
      area.addEventListener("click", this.onAreaClick.bind(this));
    });

    this.hovers = {};
  }

  hideCard(card) {
    card.classList.remove("js-visible");
  }

  showCard(card) {
    card.classList.add("js-visible");

    if (this.cards.indexOf(card) == 0) {
      this.classList.remove("js-zoom");
    } else {
      this.classList.add("js-zoom");
    }
  }

  onAreaClick(event) {
    event.preventDefault();
  }

  getLayer(id) {
    return this.layers.find((layer) => layer.dataset.layerId == id);
  }

  showLayer(id) {
    let layerShown;
    this.layers.forEach((layer) => {
      if (layer.dataset.layerId == id) {
        layer.classList.add("js-visible");
        layerShown = layer;
      } else {
        layer.classList.remove("js-visible");
      }
    });

    if (layerShown) {
      const coordX = layerShown.dataset.coordX;
      const coordY = layerShown.dataset.coordY;

      const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

      const translateX = ((coordX - 50) / 100) * 0.75;
      const translateY = ((coordY - 50) / 100) * 0.65;
      const translateXPercentage = (translateX * 100 * -1).toFixed(2) + "%";
      const translateYPercentage = (translateY * 100 * -1).toFixed(2) + "%";

      console.log("Translate", translateXPercentage);
      this.dimMap();
      this.map.style.transform = `scale(2.5) translate(${translateXPercentage}, ${translateYPercentage})`;
    } else {
      this.map.style.transform = null;
      this.undimMap();
    }
  }

  onAreaMouseEnter(event) {
    const area = event.target;
    const { layerId } = area.dataset;
    this.hovers[layerId] = true;

    const layer = this.getLayer(layerId);
    this.classList.add("js-hovered-once");

    const card = this.cards.find((card) => card.dataset.layerId == layerId);
    card.classList.add("js-visible");
    layer.classList.add("js-hover");

    this.dimMap();
  }

  onAreaMouseLeave(event) {
    const area = event.target;
    const { layerId } = area.dataset;
    delete this.hovers[layerId];

    const layer = this.getLayer(layerId);
    layer.classList.remove("js-hover");

    const card = this.cards.find((card) => card.dataset.layerId == layerId);
    card.classList.remove("js-visible");

    this.undimMap();
  }

  dimMap() {
    this.lastDimRequestTime = null;
    this.classList.add("js-hover");
  }

  undimMap() {
    const dimRequestTime = Date.now();
    this.lastDimRequestTime = dimRequestTime;

    setTimeout(() => {
      if ((this.lastDimRequestTime = dimRequestTime)) {
        if (Object.keys(this.hovers).length == 0) {
          this.classList.remove("js-hover");
        }
      }
    }, 250);
  }
}

customElements.define("barrows-green-map", BarrowsGreenMap);

class ShopScene extends HTMLElement {
  constructor() {
    super();

    this.scenes = Array.from(this.querySelectorAll("[data-scene]"));
    this.sceneSelectors = Array.from(
      this.querySelectorAll("[data-scene-selector]")
    );

    this.activeSection = this.scenes.find((scene) =>
      scene.classList.contains("js-active")
    );

    this.sceneSelectors.forEach((selector) =>
      selector.addEventListener("click", () => {
        this.showScene(
          this.scenes.find((scene) => scene.id == selector.dataset.sceneId)
        );
      })
    );

    this.scenes.forEach((scene) => {
      const showButton = scene.querySelector("[data-scene-show-button]");

      showButton.addEventListener("click", (e) => this.toggleProducts(scene));
    });
  }

  showScene(scene) {
    if (this.activeSection) {
      this.hideProducts(this.activeSection);
    }

    this.sceneSelectors.forEach((selector) =>
      selector.classList.remove("js-active")
    );

    const sceneSelector = this.sceneSelectors.find(
      (selector) => selector.dataset.sceneId == scene.id
    );

    if (sceneSelector) {
      sceneSelector.classList.add("js-active");
    }

    this.scenes.forEach((scene) => {
      scene.classList.remove("js-active");
    });

    scene.classList.add("js-active");

    this.activeSection = scene;
  }

  hideProducts(scene) {
    scene.querySelector("[data-scene-products]").classList.remove("js-active");
  }

  toggleProducts(scene) {
    scene.querySelector("[data-scene-products]").classList.toggle("js-active");
  }
}

customElements.define("shop-scene", ShopScene);

class ProductsAside extends HTMLElement {
  constructor() {
    super();
    const productsAsideDisplay = this.querySelector(
      "[data-products-aside-display]"
    );
    const productsAsideDisplays = [
      ...this.querySelectorAll("[data-products-aside-display]"),
    ];
    const productsAsideButtons = [
      ...this.querySelectorAll("[data-products-aside-button]"),
    ];

    productsAsideDisplays.forEach((display) =>
      display.classList.remove("js-open")
    );

    productsAsideButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.stopPropagation();
        productsAsideDisplay.classList.toggle("js-open");
      });
    });

    this.openProductsDisplay(productsAsideButtons);
  }

  openProductsDisplay(buttons, element) {
    buttons.forEach((button) =>
      button.addEventListener("click", (event) => {
        event.stopPropagation();
        productsAsideDisplay.classList.toggle("js-open");
      })
    );
  }
}

customElements.define("products-aside", ProductsAside);

class NavbarSubmenu extends HTMLElement {
  constructor() {
    super();

    this.forcedVisible = this.dataset.forceVisibility;

    window.addEventListener("scroll", this.onScroll.bind(this));
    window.addEventListener("resize", this.onResize.bind(this));
    this.updateVisibility();
    this.calculateRetainer();

    setTimeout(() => {
      this.calculateRetainer();
    }, 100);
  }

  isVisible() {
    this.classList.contains("js-open");
  }

  calculateRetainer() {
    if (this.dataset.forceVisibility) {
      document.getElementById("shopify-section-header").style.paddingBottom =
        this.clientHeight + "px";
    }
  }

  updateVisibility() {
    if (this.dataset.forceVisibility) {
      if (!this.forcedVisible && window.scrollY < 100) {
        this.forcedVisible = true;

        this.show();
      } else if (this.forcedVisible && window.scrollY >= 100) {
        this.forcedVisible = false;

        this.hide();
      }
    }
  }

  onResize(event) {
    this.calculateRetainer();
  }

  onScroll(event) {
    this.updateVisibility();
  }

  show() {
    this.classList.add("js-open");
  }

  hide() {
    if (!this.forcedVisible) {
      this.classList.remove("js-open");
    }
  }
}

customElements.define("navbar-submenu", NavbarSubmenu);

function showSubmenu(id) {
  const submenu = document.getElementById(`SubMenu-${id}`);
  submenu.show();
}

function hideSubmenus() {
  document.querySelectorAll("navbar-submenu").forEach((submenu) => {
    submenu.hide();
  });
}

/* Custom */

/**
 * Select current variant based on URL query ?variant=<id>
 */
document.addEventListener("DOMContentLoaded", () => {
  // Check if url is /products/
  const isProductPage = window.location.pathname.includes("/products/");

  if (isProductPage) {

    const variantId = new URLSearchParams(location.search).get("variant");
    const allVariantData = JSON.parse(document.querySelector('[type="application/json"]').textContent);
    const variant = allVariantData.find((v) => v.id == variantId)

    if (variant) {
    
      debug('Setting variant', variant)

      variant.options.forEach((option, index) => {
        // Select variant option
        const optionFieldSet = document.querySelector(`[data-variant-picker-option][data-option-field="option${index+1}"]`)

        const fieldSetType = optionFieldSet.dataset.optionFieldType
  
        if (fieldSetType === 'radio') {
          const optionInput = optionFieldSet.querySelector(`[data-option-value="${option}"] input`)
          optionInput.click()
        } else if (fieldSetType === 'select') {
          const optionSelect = optionFieldSet.querySelector(`select`)
          optionSelect.value = option
          const event = new Event('change', { bubbles: true });
          optionSelect.dispatchEvent(event);
        }
      })

      const selectors = Array.from(document.querySelectorAll('variant-radios, variant-picker, variant-selects')) 

      selectors.forEach((selector) => {
        selector.onVariantChange()
      })
    
    }
  }
})

document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll("[data-product-swatches-group]")
    .forEach((group) => {
      group.querySelectorAll("[data-product-swatches]").forEach((swatches) => {
        const valueField = swatches.querySelector(
          "[data-product-swatches-value]"
        );

        var variants = null;
        try {
          variants = JSON.parse(
            group.querySelector("script[data-product-variants]").text
          );
        } catch (e) {}
        
        const options = swatches.querySelectorAll(
          "[data-product-swatches-option]"
        );

        options.forEach(function (option) {
          option.addEventListener("click", () => {
            options.forEach((option) => option.classList.remove("js-active"));
            option.classList.add("js-active");

            const optionField = option.dataset.optionField;
            const optionName = option.dataset.optionName;
            const optionValue = option.dataset.optionValue;

            valueField.innerText = optionValue;

            console.log(
              "Selected variant option",
              optionField,
              optionName,
              optionValue
            );
          });
        });
      });
    });
});

document.addEventListener("DOMContentLoaded", () => {
  function init() {
    $("[data-featured-collection]").each(function () {
      const $section = $(this);

      const $arrowLeft = $section.find("[data-arrow-left]");
      const $arrowRight = $section.find("[data-arrow-right]");

      const $slider = $section.find("[data-featured-collection-slider]");
      const $slides = $slider.find("[data-featured-collection-slide]");

      $slider.slick({
        arrows: true, //$slides.length >= 4,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 2,
        swipe: false,
        touchMove: true,
        prevArrow: $arrowLeft,
        nextArrow: $arrowRight,
        responsive: [
          {
            breakpoint: 749,
            settings: {
              swipe: true,
              arrows: false,
              dots: $slides.length >= 2,
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
        ],
      });

      const resizeSlides = () => {
        const $slideTrack = $slider.find(".slick-track");
        const newHeight = $slideTrack.height();
        $slides.css("height", newHeight + "px");
      };

      //setTimeout(resizeSlides, 500);

      $slider.on("setPosition", resizeSlides);
    });
  }

  setTimeout(init, 100);
});

document.addEventListener("DOMContentLoaded", () => {
  function init() {
    $("[data-collection-list-section]").each(function () {
      const $collectionList = $(this);
      const $slider = $collectionList.find("[data-slider]");
      const $slides = $slider.find("[data-slide]");

      if (false) {
        $slider.slick({
          arrows: true,
          dots: false,
          centerMode: true,
          slidesToShow: 3,
          speed: 1000,

          touchMove: true,
          responsive: [
            {
              breakpoint: 749,
              settings: false
                ? {
                    speed: 800,
                    centerMode: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  }
                : "unslick",
            },
          ],
        });
      } else {
        if (window.innerWidth >= 750) {
          const container = $collectionList.get(0);
          const slider = container.children[0];
          const firstThree = [
            slider.children[0],
            slider.children[1],
            slider.children[2],
          ].filter(Boolean);

          const totalWidth = firstThree.reduce((sum, el) => {
            return el.clientWidth + sum;
          }, 0);

          const scrollLeft = Math.abs(totalWidth - window.innerWidth) / 2 + 20;

          container.scrollLeft = scrollLeft;

          dragScrollBehavior(container);
        }
      }

      if (false) {
        $slider
          .find("[data-scroll-overlay]")
          .bind("mousewheel DOMMouseScroll", (event) => {
            if (window.innerWidth < 750) return;

            let scrollTo = null;

            if (event.type == "mousewheel") {
              scrollTo = event.originalEvent.wheelDelta * -1;
            } else if (event.type == "DOMMouseScroll") {
              scrollTo = 40 * event.originalEvent.detail;
            }

            if (scrollTo) {
              event.preventDefault();

              if (scrollTo > 0) {
                $slider.slick("slickNext");
              } else if (scrollTo < 0) {
                $slider.slick("slickPrev");
              }
            }
          });
      }
    });
  }

  setTimeout(init, 100);

  document.addEventListener("shopify:section:load", init);
});

document.addEventListener("DOMContentLoaded", () => {
  const params = new URLSearchParams(location.search);

  if (params.has("debug")) {
    $("body").css({
      transform: "translateX(-" + params.get("translate", "0") + "%)",
    });

    if (params.has("width")) {
      $("body").css({
        width: params.get("width") + "px",
      });
    }
  }
});

/*
document.addEventListener("DOMContentLoaded", () => {
  $("[data-product-card-form]").each(function () {
    const $form = $(this);
    const $addToCartButton = $form.find('[name="add"]');
    this.cartNotification = document.querySelector('cart-notification');

    $form.on("submit", function (event) {
      event.preventDefault();
      console.log("Form submit");
      fetch("/cart/add.js", $form.serialize()).then(function (response) {
      })
    });
  });
});
*/

window.openCartDrawer = (event) => {
  event.stopPropagation()
  if(event.target.parentNode.classList.contains('mobile-basket') && document.querySelector('html').classList.contains('mini-cart-open')) {
    event.preventDefault()
    return
  }
  if (!window.location.pathname.startsWith("/cart")) {
    const cartDrawer = document.querySelector("cart-notification");
    console.debug("Open cart");
    setTimeout(() => cartDrawer.open(), 1);
    const htmlSelector = document.querySelector('html')
    htmlSelector.classList.add('menu-drawer-open')
    htmlSelector.classList.add('mini-cart-open')
    event && event.preventDefault();
   
  }
};

document.addEventListener("DOMContentLoaded", () => {
  if (DEBUG_MODE) {
    $("body").addClass("debug");
  }
});

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    document.body.classList.add("js-loaded");
  }, 100);
});

/* featured collection images */
window.addEventListener("load", function () {
  const images = document.querySelectorAll(".featured-collection-section .card__media-main-image");

  images.forEach(image => image.classList.add("js-display"));
});

if (!customElements.get("sticky-bottom")) {
  class StickyBottom extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const el = this;
      this.reference = this.dataset.reference;
      if (this.dataset.enabled == "false" || !this.reference) return;
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener("scroll", this.onScrollHandler, false);
      setTimeout(() => {
        el.onScroll();
      }, "1000");
    }

    onScroll() {
      const container = document.querySelector(this.reference);
      if (!container) return;
      const rect = container.getBoundingClientRect();
      let isOffScreen = rect.y + rect.height < 0 || rect.y > window.innerHeight;
      const offSetContainer = container.offsetTop;
      if (offSetContainer < window.scrollY && isOffScreen) {
        this.addSticky();
      } else {
        this.removeSticky();
      }
    }

    removeSticky() {
      document.body.classList.remove("sticky-bottom--active");
    }

    addSticky() {
      document.body.classList.add("sticky-bottom--active");
    }
  }

  customElements.define("sticky-bottom", StickyBottom);
}

// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value).replace(".00", '');
};

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    const paymentTerms = document.querySelector("shopify-payment-terms");
    if (paymentTerms && paymentTerms.shadowRoot) {
      const paymentBanner = paymentTerms.shadowRoot.querySelector("shop-pay-installments-banner");
      if (paymentBanner && paymentBanner.shadowRoot) {
        const minAmount = paymentBanner.shadowRoot.querySelector(".shopify-installments__content b");
        if (minAmount) {
          minAmount.setAttribute("style", "font-weight: 400");
        }
      }
    }  
  }, 2000);
});